<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none site-logo" to="/dashboard">
      <!-- CIcon name="logo" height="48" alt="Logo"/ -->
      <img src="@/assets/images/liberty-resort-black.png" height="48" alt="LibertyResort" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3"> </CHeaderNavItem>
      <CHeaderNavItem class="px-3"> </CHeaderNavItem>
    </CHeaderNav>
    <transition name="fade">
      <CHeaderNav class="mx-4" v-if="loading">
        <!-- <TheHeaderDropdownAccnt/> -->
        {{ fullName }} {{ loginRole }}
      </CHeaderNav>
    </transition>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0" />
    </CSubheader>
  </CHeader>
</template>

<script>
// import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import axios from "axios";

const ROLE = {
  ADMIN: "liberty_operator_admin",
  OPERATOR: "liberty_operator",
  MEMBER: "liberty_member",
};

export default {
  name: "TheHeader",
  components: {
    // TheHeaderDropdownAccnt
  },

  data() {
    return {
      user: { cardId: 0, address: {}, points: {} },
      fullName: "",
      loading: false,
    };
  },

  methods: {
    getUserInformation: function () {
      //Login as registered user
      // console.log("Keycloak data: " + this.$keycloak.$data);
      // console.log("Keycloak logoutFn: " + this.$keycloak.logoutFn);
      var urlRequest = "/rest/currentuser";

      axios({
        url: urlRequest,
        method: "GET",
        headers: { Authorization: `Bearer ${this.$keycloak.token}` },
      })
        .then((resp) => {
          this.user = resp.data;
          this.fullName = this.user.familyName + " " + this.user.givenName;
          // console.log("(header) user: " + JSON.stringify(this.user));
          this.loading = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  computed: {
    // fullName() {
    //   return this.user.familyName + " " + this.user.givenName;
    // },
    loginRole() {
      // オペレーターか管理者であればロール名を返す
      const roles = this.$keycloak.realmAccess.roles;
      let loginRole = "様";
      if (roles.includes(ROLE.ADMIN)) {
        loginRole = " (管理者)";
      } else if (roles.includes(ROLE.OPERATOR)) {
        loginRole = " (オペレータ)";
      }
      return loginRole;
    },
  },

  beforeMount() {
    this.getUserInformation();
  },
};
</script>
